var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"mapRef",staticClass:"client-map",style:('width:400px;height:300px'),attrs:{"center":_vm.center,"zoom":_vm.zoom,"tilt":0,"map-type-id":"hybrid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }